import PicabooConstants from '../common/PicabooConstants';
import FabricAlmond from '../public/images/covertools/Almond_Fabric_Seamless.png';
import FabricCanary from '../public/images/covertools/Canary_Fabric_Seamless.png';
import FabricClay from '../public/images/covertools/Clay_Fabric_Seamless.png';
import FabricFog from '../public/images/covertools/Fog_Fabric_Seamless.png';
import FabricLilac from '../public/images/covertools/Lilac_Fabric_Seamless.png';

export function fabricCoverImages() {
  let coverImages = {};

  return coverImages;
}

export function getFabricImage(style) {
  return fabricCoverImages()[style];
}
